import { IFormOption } from '../data/utils/form';
import { formOption } from './formOption';

export const booleanOptions: IFormOption[] = [
    formOption('yes', 'Yes'),
    formOption('no', 'No'),
];
